import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from 'src/@smartmanufacturing/common/constants';


@Injectable({
  providedIn: 'root'
})
export class FormBuilderUDFService {
  baseUrl: string = Constants.CORE_API_BASE_URL;
  constructor(private http: HttpClient) { }

  saveForm(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'FormBuilder/saveForm', data);
  }

  getFormByModulePage(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'FormBuilder/getFormByModulePage', data);
  }
  getFormByModuleAndPage(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'FormBuilder/getFormByPage', data);
  }

  getDataFromAPI(data: any, APIURL: string, requestType: string): Observable<any> {
    switch (requestType.toLowerCase()) {
      case 'post':
        return this.http.post<any>(this.baseUrl + APIURL, data);
      case 'put':
        return this.http.put<any>(this.baseUrl + APIURL, data);
      case 'delete':
        return this.http.delete<any>(this.baseUrl + APIURL, { body: data });
      case 'patch':
        return this.http.patch<any>(this.baseUrl + APIURL, data);
      case 'get':
      default:
        return this.http.get<any>(this.baseUrl + APIURL);
    }
  }

  saveFormData(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'FormBuilder/saveFormData', data);
  }

  fetchFormData(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'FormBuilder/fetchFormData', data);
  }

  getPages(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'FormBuilder/getPages', data);
  }

  getAPIList(): Observable<any> {
    return this.http.get<any>(this.baseUrl + 'FormBuilder/getAPIList');
  }

  getFormsTable(): Observable<any> {
    return this.http.get<any>(this.baseUrl + 'FormBuilder/getFormsForTable');
  }

  saveWorkflow(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'Workflow/saveWorkflow', data);
  }
  getWorkflows(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'Workflow/getWorkflows', data);
  }
  deleteWorkflow(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'Workflow/deleteWorkflow', data);
  }
  getFormSubmissionsForApproval(): Observable<any> {
    return this.http.get<any>(this.baseUrl + 'Workflow/getWorkflowsByApprover');
  }
  approveWorkflowLevel(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'Workflow/ApproveWorkflowItem', data);
  }
  rejectWorkflowLevel(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'Workflow/RejectWorkflowItem', data);
  }
  getWorkflowInstanceApprovalMatrix(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'Workflow/GetWorkflowApprovalMatrix', data);
  }
  fetchSubmittedData(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'Workflow/GetFormSubmittedData', data);
  }
  getUIBuilderPages(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'Workflow/getUIBuilderPages', data);
  }

  loadWFDashboard(data:any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'Workflow/getDashboard', data);
  }
  getPendingApprover(data:any):Observable<any> {
    return this.http.post<any>(this.baseUrl + 'Workflow/getWorkflowUnifiedList', data);
  }

    getPublishedPages(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'Workflow/getPublishedPages', data);
  }

  createNCR(data: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'Formbuilder/CreateNCR', data);
  }

}